import "./components/0-base/global.css";
import App from "./components/5-app/App.tsx";

export default App;
